export class NotificationBoard {
  constructor() {}

  movingOutPremises: number = 0;
  movingOutTenants: number = 0;
  draftLeaseAgreementsDwelling: number = 0;
  draftLeaseAgreementsOther: number = 0;
  draftLeaseAgreementsParking: number = 0;
  draftLeaseAgreementsPremises: number = 0;
  newFaultNotifications: number = 0;
  overdueInvoices: number = 0;
  nonDeliverableEmailInvoices: number = 0;
  notAttestedInvoices: number = 0;
  incorrectPayments: number = 0;
  banktransactionImportsUnManaged: number = 0;
  terminationMonitoringLeaseAgreementsDwelling: number = 0;
  terminationMonitoringLeaseAgreementsOther: number = 0;
  terminationMonitoringLeaseAgreementsPremises: number = 0;
  terminationMonitoringLeaseAgreementsParking: number = 0;
}
